import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'proptypes';
import { seatsLeftEvaluator, formatDate } from './../../../helpers/TripHelper';
import { readableResponseMessage } from './../../../helpers/local_modules/ux-helpers';

class TripAddOns extends Component {
  state = {
    tripIndex: this.props.user.trips.map(trip => trip.id).indexOf(this.props.tripId),
    toggledIndeces: [],
  };

  toggleDescription = addOnIndex => {
    const { toggledIndeces } = this.state;

    if (!toggledIndeces.includes(addOnIndex)) {
      toggledIndeces.push(addOnIndex);
      this.setState({
        toggledIndeces,
      });
    } else {
      toggledIndeces.splice(toggledIndeces.indexOf(addOnIndex), 1);
      this.setState({
        toggledIndeces,
      });
    }
  };

  addTripAddOn = (addOn, tripIndex) => {
    const currentAddOns = this.props.user.trips[tripIndex];

    currentAddOns.push(addOn);

    this.props.setTripState(tripIndex, this.props.user.trips[tripIndex]);
  };

  scrollTo = (e, id) => {
    e.preventDefault();
    const scrollElement = document.getElementById(id);
    if (scrollElement && scrollElement.offsetTop) {
      window.scrollTo({
        top: scrollElement.offsetTop - 100,
        behavior: 'smooth',
      });
    }
  };

  addOnSubmit = (e, addOn, addOnIndex, tripIndex) => {
    e.preventDefault();
    //specifies which loading button to animate
    this.setState({ [addOnIndex]: true });

    this.props
      .addTripAddOn(addOn, addOnIndex, tripIndex)
      .then(res => {
        this.setState({ [addOnIndex]: false });
        window.scrollTo({
          top: 400,
          behavior: 'smooth',
        });
      })
      .catch(error => {
        this.setState({
          [addOnIndex]: false,
          message: readableResponseMessage(error),
        });
      });
  };

  render() {
    return this.props.availableAddOns.length ? (
      <div className="trip-add-ons row">
        {this.props.viewMode === 'comprehensive' ? (
          <Fragment>
            <div className="col-md-12 col-sm-12 no-padding-col" id="add-ons">
              <h3 className="h1-style muted">Extend Your Trip!</h3>
              <h5 className="brand-primary">
                Over 50% of our volunteers extend their trip with an add-on.
              </h5>
            </div>
            {this.props.availableAddOns.map((addOn, addOnIndex) => (
              <div className="row" key={addOn.id} id={addOn.id}>
                <div className="col-md-12 no-padding-col">
                  <span className="icon-container world-icon" />
                  <h4>
                    {addOn.name} {formatDate(addOn.addOnStartDate, addOn.addOnEndDate)}
                  </h4>
                </div>
                {addOn.content && Object.keys(addOn.content).length ? (
                  <Fragment>
                    {addOn.content.imageUrl &&
                    addOn.content.imageUrl !== undefined &&
                    (!addOn.content.videoUrl || addOn.content.videoUrl === undefined) ? (
                      <div className="no-padding-col col-md-12">
                        <img
                          style={{ width: '100%' }}
                          src={addOn.content.imageUrl}
                          alt="add-on"
                          width="360"
                          height="202.5"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    {addOn.content.videoUrl && addOn.content.videoUrl !== undefined ? (
                      <div className="no-padding-col col-md-12">
                        <div className="resp-container">
                          <iframe
                            id={addOn.content.id}
                            className="resp-iframe"
                            title="add-on video"
                            frameBorder="0"
                            padding="0"
                            margin="0"
                            allowFullScreen
                            allow="autoplay; encrypted-media"
                            src={addOn.content.videoUrl.replace(
                              'youtu.be/',
                              'www.youtube.com/embed/'
                            )}
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}

                    <div className="no-padding-col col-md-12">
                      <button
                        className="btn-plain-text small"
                        onClick={() => {
                          this.toggleDescription(addOnIndex);
                        }}
                      >
                        {this.state.toggledIndeces.includes(addOnIndex) ? 'Hide' : 'Show'} volunteer
                        trip details
                      </button>
                      {this.state.toggledIndeces.includes(addOnIndex) ? (
                        <p className="trip-description no-margin-text">
                          {addOn.content.description}
                        </p>
                      ) : (
                        ''
                      )}
                    </div>
                  </Fragment>
                ) : (
                  ''
                )}
                {addOn.displaySeatsLeft > 0 ? (
                  <div className="col-md-12 no-padding-col button-margin">
                    <button
                      className={`${this.state[addOnIndex] ? 'btn-text-hide' : ''}`}
                      onClick={e => this.addOnSubmit(e, addOn, addOnIndex, this.state.tripIndex)}
                      disabled={this.state[addOnIndex] || this.props.isProcessing}
                    >
                      Add to your trip!
                      <span className={`${this.state[addOnIndex] ? 'loader loader-addon' : ''}`} />
                    </button>
                    <span className="error">{seatsLeftEvaluator(addOn.displaySeatsLeft)}</span>
                  </div>
                ) : (
                  <div className="col-md-12 no-padding-col button-margin">
                    {seatsLeftEvaluator(addOn.displaySeatsLeft)}
                  </div>
                )}
              </div>
            ))}
          </Fragment>
        ) : (
          <div className="col-md-12 no-padding-col addon-tickets-container">
            {this.props.availableAddOns.map((addOn, addOnIndex) => (
              <div key={addOn.id} className="addon-ticket styled-container flex">
                <div className="flex">
                  <span className="icon-container world-icon" />
                  <h4 className="muted addon-name">
                    <div className="small muted">Trip Add-On:</div>
                    {addOn.name} {formatDate(addOn.addOnStartDate, addOn.addOnEndDate)}
                    <button
                      className="btn-plain-text small"
                      onClick={e => this.scrollTo(e, addOn.id)}
                    >
                      Learn More
                    </button>
                  </h4>
                </div>
                {addOn.displaySeatsLeft > 0 ? (
                  <Fragment>
                    <button
                      className={`${this.state[addOnIndex] ? 'btn-text-hide' : ''}`}
                      onClick={e => this.addOnSubmit(e, addOn, addOnIndex, this.state.tripIndex)}
                      disabled={this.state[addOnIndex] || this.props.isProcessing}
                    >
                      Add to your trip!
                      <span className={`${this.state[addOnIndex] ? 'loader loader-addon' : ''}`} />
                    </button>
                  </Fragment>
                ) : (
                  <div className="flex inline">{seatsLeftEvaluator(addOn.displaySeatsLeft)}</div>
                )}
              </div>
            ))}
          </div>
        )}
        {this.state.message ? <span className="error">{this.state.message}</span> : ''}
      </div>
    ) : (
      ''
    );
  }
}

TripAddOns.propTypes = {
  availableAddOns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      productId: PropTypes.string,
      tripId: PropTypes.string,
      content: PropTypes.shape({
        videoUrl: PropTypes.string,
        imageUrl: PropTypes.string,
        description: PropTypes.string,
      }),
    })
  ).isRequired,
  updateTripCost: PropTypes.func.isRequired,
  hasPaidDeposit: PropTypes.bool.isRequired,
  tripId: PropTypes.string.isRequired,
  addTripAddOn: PropTypes.func,
  setParentTripValue: PropTypes.func,
  setTripState: PropTypes.func,
  viewMode: PropTypes.string,
  setOpportunityScrollTo: PropTypes.func,
  isProcessing: PropTypes.bool,
};

TripAddOns.defaultProps = {
  setOpportunityScrollTo: () => {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    });
  },
  viewMode: '',
};

export default withRouter(TripAddOns);
